// // website_kanaksuri/src/api.js
// export const BACKEND_URL =
//   process.env.NODE_ENV === "development"
//     ? "http://localhost:8080" 
//     : process.env.REACT_APP_BACKEND_URL || "https://api.shreekanaksuriahinsadham.com";

// export const API_BASE = BACKEND_URL;

// export async function fetchJSON(endpoint, options = {}) {
//   const url = `${API_BASE}${endpoint}`;
//   const response = await fetch(url, options);

//   let data;
//   try {
//     data = await response.json();
//   } catch (parseError) {
//     throw new Error(`Invalid JSON response: ${parseError.message}`);
//   }

//   if (!response.ok) {
//     throw new Error(data.error || 'Request failed');
//   }
//   return data;
// }

// website_kanaksuriahinsadham/src/api.js
export const BACKEND_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:8080"
    : process.env.REACT_APP_BACKEND_URL || "https://api.shreekanaksuriahinsadham.com";

export const API_BASE = BACKEND_URL;

export async function fetchJSON(endpoint, options = {}) {
  const url = `${API_BASE}${endpoint}`;
  const response = await fetch(url, options);

  let data;
  try {
    data = await response.json();
  } catch (parseError) {
    throw new Error(`Invalid JSON response: ${parseError.message}`);
  }

  if (!response.ok) {
    throw new Error(data.error || 'Request failed');
  }
  return data;
}

export async function submitCashDonation(donationData) {
  return await fetchJSON('/api/cash-donation', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(donationData),
  });
}

export async function verifyOnlineDonation(paymentData) {
  return await fetchJSON('/api/verify-payment', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(paymentData),
  });
}

export async function requestDonorOTP(phoneNumber) {
  return await fetchJSON('/api/donor-auth/request-otp', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ phoneNumber }),
  });
}

export async function verifyDonorOTP(phoneNumber, otp) {
  return await fetchJSON('/api/donor-auth/verify-otp', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ phoneNumber, otp }),
  });
}
